<!-- ordinal of fifty to allow the page to have buttons to the left -->
<div adaptToolbarContent
     [ordinal]="50">
    <span class="dx-datagrid-export-button">
        <button adaptButtonIcon="dx-icon dx-icon-xlsxfile"
                adaptTooltip="Export all data"
                (click)="exportAllData()"
                data-test="export-data-button"></button>
    </span>
    <button adaptButtonIcon="dx-icon dx-icon-column-chooser"
            adaptTooltip="Column chooser"
            (click)="showColumnChooser()"></button>
    <button adaptButtonIcon="dx-icon dx-icon-revert"
            adaptTooltip="Reset columns"
            (click)="resetColumns()"></button>
</div>

<dx-data-grid [dataSource]="peopleData"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              (onInitialized)="onInitialized($event)"
              [columnAutoWidth]="true"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              data-test="manage-people-grid">
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-paging [pageSize]="25"> </dxo-data-grid-paging>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
    <dxo-data-grid-scrolling [useNative]="false"> </dxo-data-grid-scrolling>
    <dxo-data-grid-column-chooser [enabled]="false"> </dxo-data-grid-column-chooser>
    <dxo-data-grid-load-panel [enabled]="true"> </dxo-data-grid-load-panel>
    <dxo-data-grid-column-fixing [enabled]="true"> </dxo-data-grid-column-fixing>

    <dxi-data-grid-sort-by-group-summary-info summaryItem="custom"></dxi-data-grid-sort-by-group-summary-info>
    <dxo-data-grid-summary [calculateCustomSummary]="calcConnectionTypeCustomSummary">
        <dxi-data-grid-group-item summaryType="custom"
                                  name="connectionTypeCustomSummary"
                                  showInColumn="Connection type"></dxi-data-grid-group-item>
        <dxi-data-grid-group-item summaryType="count"
                                  name="connectionTypeCountSummary"
                                  showInColumn="Connection type"></dxi-data-grid-group-item>
        <dxi-data-grid-total-item displayFormat="Total People: {0}"
                                  showInColumn="People"
                                  summaryType="count"> </dxi-data-grid-total-item>
    </dxo-data-grid-summary>

    <!-- COLUMNS -->
    <dxi-data-grid-column caption="Connection type"
                          dataField="connectionType"
                          dataType="string"
                          [groupIndex]="0"
                          groupCellTemplate="connectionTypeTemplate"
                          [calculateGroupValue]="calculateGroupValue"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Full name"
                          dataField="person.fullName"
                          dataType="string"
                          name="People"
                          cellTemplate="fullNameCellTemplate"
                          [width]="210"
                          sortOrder="asc"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Status"
                          dataField="status"
                          [calculateCellValue]="calculateActiveCellValue"
                          dataType="string"
                          [allowSorting]="true"
                          [allowFiltering]="true"
                          [showEditorAlways]="false"
                          [editorOptions]="{ disabled: true }"
                          [filterOperations]="[]"
                          [filterValues]="['Active', 'Pending Active']"> </dxi-data-grid-column>

    @if (isAlto) {
        <dxi-data-grid-column caption="Role in organisation"
                              dataField="roleInOrganisation"
                              dataType="string"
                              [allowSorting]="true"
                              [allowFiltering]="true"
                              [showEditorAlways]="false"
                              [calculateCellValue]="calculateRoleInOrganisationCellValue"
                              [visible]="true">
            <dxo-data-grid-header-filter [dataSource]="roleInOrganisationHeaderItems"> </dxo-data-grid-header-filter>
        </dxi-data-grid-column>
    }

    @if (!isAlto) {
        <dxi-data-grid-column caption="Login allowed"
                              dataField="hasAccess"
                              dataType="boolean"
                              [allowSorting]="true"
                              [allowFiltering]="true"
                              [showEditorAlways]="false"
                              [visible]="true"
                              cellTemplate="hasAccessCellTemplate"> </dxi-data-grid-column>
    }

    @if (!isAlto) {
        <dxi-data-grid-column caption="User type"
                              dataField="userType"
                              dataType="string"
                              [allowSorting]="true"
                              [allowFiltering]="true"
                              [showEditorAlways]="false"
                              [calculateCellValue]="calculateAccessLevelCellValue"
                              [visible]="true"> </dxi-data-grid-column>
    }

    <dxi-data-grid-column caption="Access levels"
                          cellTemplate="accessLevelsCellTemplate"
                          [calculateCellValue]="calculateAccessLevelsCellValue"
                          dataType="string"
                          dataField="accessLevel"
                          [allowSorting]="true"
                          [allowFiltering]="true"
                          [filterValue]="accessLevelLabelFilter">
        <dxo-data-grid-header-filter [dataSource]="accessLevelHeaderItems"> </dxo-data-grid-header-filter>
    </dxi-data-grid-column>

    @if (!isAlto) {
        <dxi-data-grid-column caption="Roles"
                              cellTemplate="roleCellTemplate"
                              [calculateCellValue]="calculateRolesCellValue"
                              dataType="string"
                              dataField="role"
                              [allowSorting]="true"
                              [allowFiltering]="true"
                              [filterValue]="roleLabelFilter">
            <dxo-data-grid-header-filter [dataSource]="roleHeaderItems"> </dxo-data-grid-header-filter>
        </dxi-data-grid-column>
    }

    <dxi-data-grid-column caption=""
                          dataType="string"
                          dataField="actions"
                          cellTemplate="actionCellTemplate"
                          [allowSorting]="false"
                          [allowReordering]="false"
                          [allowHiding]="false"
                          [allowFiltering]="false"
                          [allowResizing]="false"
                          [fixed]="true"
                          fixedPosition="right"
                          [width]="50"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Last access"
                          [calculateCellValue]="calculateLastAccessDate"
                          dataField="dummyLastAccess"
                          dataType="date"
                          [format]="dateFormat"
                          [allowFiltering]="true"
                          [allowSorting]="true"
                          [visible]="false"
                          [width]="180"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Invitation email sent"
                          [calculateCellValue]="calculateWelcomeEmailDate"
                          dataField="dummyWelcomeEmail"
                          dataType="date"
                          [format]="dateFormat"
                          [allowFiltering]="true"
                          [allowSorting]="true"
                          [visible]="false"
                          [width]="210"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Start date"
                          dataType="date"
                          dataField="startDate"
                          [format]="ShortDate"
                          [allowFiltering]="true"
                          [allowSorting]="true"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="End date"
                          dataType="date"
                          dataField="endDate"
                          [format]="ShortDate"
                          [allowFiltering]="true"
                          [allowSorting]="true"
                          [visible]="false"> </dxi-data-grid-column>
    <!-- END COLUMNS -->

    <!-- TEMPLATES -->
    <div *dxTemplate="let item of 'connectionTypeTemplate'">{{ item.value }} ({{ getConnectionTypeSummaryCount(item) }})</div>

    <div *dxTemplate="let item of 'fullNameCellTemplate'">
        <adapt-link-person [person]="item.data.person"
                           [showImage]="true"
                           imageSize="sm"></adapt-link-person>
    </div>

    <div *dxTemplate="let item of 'roleCellTemplate'"
         class="roles-cell">
        <ul>
            @for (roleConnection of getNonTeamBasedRoleConnectionsForConnection(item.data, false); track trackByRoleConnectionId($index, roleConnection)) {
                <li>
                    <adapt-link-role [role]="roleConnection.role"></adapt-link-role>
                </li>
            }
        </ul>
    </div>

    <div *dxTemplate="let item of 'accessLevelsCellTemplate'"
         class="roles-cell">
        <ul>
            @for (roleConnection of getNonTeamBasedRoleConnectionsForConnection(item.data, true); track trackByRoleConnectionId($index, roleConnection)) {
                <li>
                    <adapt-link-access-level [role]="roleConnection.role"></adapt-link-access-level>
                </li>
            }
        </ul>
    </div>

    <div *dxTemplate="let item of 'hasAccessCellTemplate'">
        @if (item.value) {
            <dx-check-box [value]="true"
                          [readOnly]="true"></dx-check-box>
        }
    </div>

    <div *dxTemplate="let item of 'actionCellTemplate'">
        <adapt-user-role-actions [connection]="item.data"
                                 (connectionChanged)="promiseToGetPeopleData()"
                                 (refreshRequired)="updateGridDimensions()"></adapt-user-role-actions>
    </div>
    <!-- END TEMPLATES -->
</dx-data-grid>
